/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, Button } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 5
  },
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  itemNested: {
    paddingLeft: '10px',
    display: 'block'
  },
  button: {
    fontFamily: 'PT serif',
    fontSize: '16px',
    color: '#6D7278',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    borderLeft: '5px solid',
    marginBottom: '5px',
    background: 'rgba(0,0,255, 0.05)',
    '& $icon': {
      color: theme.palette.primary.main
    }
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
));

const SidebarNav = (props) => {
  const { pages, className, ...rest } = props;
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const classes = useStyles();

  return (
    <List {...rest} className={clsx(classes.root, className)}>
      {pages.map((page) => {
        if (page.title === "Let's Analyze") {
          return (
            <>
              <ListItem
                key={page.title}
                button
                className={classes.item}
                disableGutters
                onClick={handleClick}>
                <Button className={classes.button}>{page.title}</Button>
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <ListItem
                  key={page.title}
                  className={classes.itemNested}
                  disableGutters>
                  <Button
                    activeClassName={classes.active}
                    className={classes.button}
                    component={CustomRouterLink}
                    to={page.href1}>
                    {page.subTitle1}
                  </Button>
                  <Button
                    activeClassName={classes.active}
                    className={classes.button}
                    component={CustomRouterLink}
                    to={page.href2}>
                    {page.subTitle2}
                  </Button>
                </ListItem>
              </Collapse>
            </>
          );
        }
        return (
          <ListItem key={page.title} className={classes.item} disableGutters>
            <Button
              activeClassName={classes.active}
              className={classes.button}
              component={CustomRouterLink}
              to={page.href}>
              {page.title}
            </Button>
          </ListItem>
        );
      })}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string.isRequired,
  pages: PropTypes.array.isRequired
};

export default SidebarNav;
